import { Avatar, Typography } from 'antd';
import React, { FC } from 'react';
import { FONT } from '../../styles/color';
import { StylePageSubtitle, StylePageTitle } from '../../styles/sharedStyleComponets';

type BookingSummary = {
  specialist: {
    title: string;
    avatarURL: string;
    displayName: string;
    specialityInfo: string;
  }
  appointment: {
    startDateTime: string;
  }
}

type BookingConfirmPanelProps = {
  bookingSummary: BookingSummary,
}

type BookingSummaryPanelProps = {
  bookingSummary: BookingSummary,
}

const BookingSummaryPanel: FC<BookingSummaryPanelProps> = ({ bookingSummary }) => {
  const {
    specialist: {
      avatarURL, displayName, specialityInfo, title,
    },
    appointment: { startDateTime },
  } = bookingSummary;
  return (
    <div style={{ textAlign: 'center', marginTop: '30px' }}>
      <Avatar src={avatarURL} size={150} style={{ marginBottom: '30px' }} />
      <Typography.Title level={3} style={{ color: FONT }}>{`${title} ${displayName}`.trim()}</Typography.Title>
      <Typography.Paragraph style={{ fontSize: '14px' }}>{specialityInfo}</Typography.Paragraph>
      <Typography.Paragraph strong style={{ fontSize: '16px', color: FONT }}>{startDateTime}</Typography.Paragraph>
    </div>
  );
};

export const BookingConfirmPanel: FC<BookingConfirmPanelProps> = ({
  bookingSummary,
}) => (
  <>
    <StylePageTitle level={2}>
      Confirm your Booking
    </StylePageTitle>
    <StylePageSubtitle>
      Please note that the virtual psychology clinic is not a crisis service.
      <br />
      If you are experiencing an emergency, dial 000 or Lifeline 13 11 14.
    </StylePageSubtitle>
    <StylePageSubtitle>
      Please confirm the following booking information.
    </StylePageSubtitle>
    <BookingSummaryPanel bookingSummary={bookingSummary} />
  </>
);
